// request.tsx
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddDCConnection {
	subId: string;
	datacenterIdSource: string;
	hardwareIdSource: number | null;
	portIdSource: number | null;
	capacityMbps: number;
	connectionType: string;
	datacenterIdDest?: string | number;
	datacenterSource?: string | null;
	hardwareIdDest?: number | null;
	portIdDest?: number | null;
	id?: number;
	metadata?: object;
}

// GET /v1/dataCentersConnection
export function getAllDatacenterConnections(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/datacenter-connections`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

// GET /v1/dataCentersConnection/:id
export function getDatacenterConnectionById(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.get(`${API_URL}/v1/resource-manager/datacenter-connections/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

// POST /v1/dataCentersConnection
export function createDatacenterConnection(token: string, payload: AddDCConnection) {
	return axios.post(`${API_URL}/v1/resource-manager/datacenter-connections`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

// PUT /v1/dataCentersConnection/:id
export function updateDatacenterConnection(token: string, id: number, payload: AddDCConnection) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/resource-manager/datacenter-connections/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

// DELETE /v1/dataCentersConnection/:id
export function deleteDatacenterConnection(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/resource-manager/datacenter-connections/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
